

















import { defineComponent, PropType, ref } from "@vue/composition-api";
import { InputAiUserQuestionaryUpdate } from "@scrile/api-provider/dist/projects/scrileConnect/AiUserQuestionaryProvider";
import { FormValues } from "@/types";
import BaseButton from "@/components/BaseButton";
import BaseForm from "@/components/BaseForm";
import PageTitle from "@/components/PageTitle";
import { fields, QuestionnaireBlock } from "../../config";

export default defineComponent({
  name: "AiQuestionaryEdit",
  components: { BaseForm, BaseButton, PageTitle },
  props: {
    blockName: { type: String as PropType<QuestionnaireBlock>, required: true },
    initValues: { type: Object as PropType<InputAiUserQuestionaryUpdate["fields"]>, default: () => {} },
  },
  setup(props, { emit }) {
    const processing = ref(false);
    const values = ref<FormValues>({ ...props.initValues });
    const valid = ref(false);

    const onSave = () => {
      if (!valid.value) return;
      processing.value = true;
      emit("save", values.value, () => {
        processing.value = false;
        emit("close");
      });
    };

    return {
      processing,
      values,
      valid,
      fields,
      onSave,
    };
  },
});
